<template>
  <!-- `filterable="false"` NO es cosmetico: sin el, vue-select vuelve a filtrar EN EL
       CLIENTE la lista que ya trajo el servidor, comparando cada `label` contra lo que
       se escribio. Con el buscador difuso eso tira justo los resultados buenos: al
       escribir "ACETAMINOFEM" el backend devuelve ACETAMINOFEN y el componente los
       descarta porque el label no contiene esa cadena. La pantalla queda "sin
       resultados" aunque la API respondio bien.
       En busqueda remota el servidor ya decidio que mostrar y en que orden. -->
  <v-select
      :filterable="false"
      label="label"
      :options="list"
      :reduce="result => mode === 'object' ? result : result.id"
      @search="debounceSearch"
      @input="setChange"
      :class="classObject"
      v-model="selected"
  >
    <template #no-options="{ search }">
      No se encontraron resultados para <strong>{{ search }}</strong>
    </template>
    <template #search="{ attributes, events }">
      <input
          class="vs__search"
          :class="classObject"
          v-bind="attributes"
          v-on="events"
      />
    </template>
  </v-select>
</template>
<script>
import _service from "../../services/servicioService";
import {isEmpty, debounce} from 'lodash';
import VSelect from 'vue-select';

export default {
  props: ["value", "mode", "validator", "groups"],
  components : {VSelect},
  data() {
    return {
      selected : this.value,
      list: [],
    };
  },
  created() {
    this.debounceSearch = debounce(this.search, 500);
  },
  watch : {
    value : {
      handler : async function(value){

        if(this.mode === 'object'){
          if(isEmpty(value) || value === undefined || value === null){
            this.selected = {};
            return;
          }
        }else{
          if(value === '' || value === undefined || value === null){
            this.selected = '';
            return;
          }
        }

        let id = this.mode === 'object' ? value.id : value;
        if(!id){
          this.selected = value;
          return;
        }

        if(isEmpty(this.list.find(x => x.id === id))){
          try {
            let response = await _service.show(id);
            if(response && response.data){
              this.list.push({
                ...response.data,
                label : `${response.data.codigo} - ${response.data.descripcion}`,
                id : response.data.id
              });
            }
          } catch(e) {
            console.error(e);
          }
        }

        this.selected = value;
      },
      deep : false,
    }
  },
  methods: {
    async search(search, loading) {

      if(search === '')  return;

      loading(true);

      let response = await _service.index(search, {
        params : {
          groups : this.groups
        }
      });
      this.list = response.data.map(x=>{
        return {
          ...x,
          id:x.id,
          codigo:x.codigo,
          label:`(${x.codigo}) ${x.descripcion} `,
          descripcion: x.descripcion,
        }
      });

      loading(false);
    },
    setChange(value){
      this.$emit('input', value);
    }
  },
  computed : {
    classObject : function (){

      if(this.validator === undefined || this.validator === null){
        return '';
      }

      return this.validator.$error ? 'v-select-error is-invalid' : 'is-valid';
    }
  }
}
</script>



